import api from './client';
import ApiError from './error';

const NotificationService = {
  async getAllNotifications() {
    try {
      const client = await api.getClient();
      return client.listPushNotifications();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async listNotificationTopics() {
    try {
      const client = await api.getClient();
      return client.listNotificationTopics();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createNotificationTopic({ data }) {
    try {
      const client = await api.getClient();
      return client.createNotificationTopic(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateNotificationTopic({ id, data }) {
    try {
      const client = await api.getClient();

      // Axios takes it as an actual error and rejects the promise
      client.interceptors.response.use((response) => response, (error) => {
        if (error.response.status === 303) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.updateNotificationTopic(id, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteNotificationTopic({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteNotificationTopic(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async sendNotification({ data }) {
    try {
      const client = await api.getClient();
      return client.sendNotification(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteNotificationMessage({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteNotificationMessage(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default NotificationService;
